export default __webpack_public_path__ + "static/media/reset.55167157.svg";